import _ from "lodash";
import React from "react";
import classes from "./ResourceCard.scss";
import { DEFAULT_PROFILE_PIC, getThumbBaseUrl } from "store/static";
import classNames from "classnames";
import { Tick } from "SvgComponents";
import ProfileAvtar from "UIComponents/ProfileAvtar";
import { getCloudUrl } from "Constants";
import { openLinkInNewTab } from "modules/Services";
import { connect } from "react-redux";

const BROKEN_IMAGE_URL = `${getCloudUrl()}/assets/webapp/BrokenImage.svg`;

const getDataForService = ({
  firstName,
  lastName,
  userName,
  currentImageService,
  profileUrl,
}) => {
  switch (currentImageService) {
    case "PIXABAY":
      return {
        profileName: userName,
        authorUrl: `https://pixabay.com/users/${userName}`,
        siteUrl: "https://pixabay.com/",
      };
    case "UNSPLASH":
      return {
        profileName: `${firstName ? firstName : `Untitled`} ${
          lastName ? lastName : ``
        }`,
        authorUrl: `http://unsplash.com/@${userName}`,
        siteUrl: "https://unsplash.com/",
      };
    case "PEXELS":
      return {
        profileName: userName,
        authorUrl: profileUrl,
        siteUrl: "https://www.pexels.com/",
      };
  }
};

class ResourceCard extends React.Component {
  isSelected = () => {
    const selectedResources = this.props.selectedResources;
    const resourceId = this.props.resource.url;
    return _.findIndex(selectedResources, { url: resourceId }) >= 0;
  };

  toggleSelectedResources = () => {
    const { selectedResources, resource, id, multi, t } = this.props;

    const index = _.findIndex(selectedResources, { url: resource.url });
    let param = {};
    if (index >= 0) {
      param = { data: "", index: index, type: "delete", multi };
    } else {
      param = { data: resource, index: "", type: "add", multi };
    }

    this.props.toggleSelectedResources(param, id);
  };

  onClickView = (e, url) => {
    url += `?utm_source=toddle&utm_medium=referral`;
    e.stopPropagation();
    this.props.openLinkInNewTab({ url: url });
  };

  render() {
    const {
      currentImageService,
      resource,
      t,
      some,
      id,
      index,
      onKeyDown,
      resourceCardRefs,
    } = this.props;

    const { source, thumbURL, author } = resource;

    const { userName, imageUrl, firstName, lastName, profileUrl } =
      author || {};

    const profileImage = imageUrl
      ? `${getThumbBaseUrl()}48x48/${imageUrl}`
      : `${DEFAULT_PROFILE_PIC}`;

    const selectClassName = classNames(
      { [classes.container]: true },
      { [classes.selectedContainer]: this.isSelected() }
    );

    const { profileName, authorUrl, siteUrl } = getDataForService({
      userName,
      firstName,
      lastName,
      currentImageService,
      profileUrl,
    });

    const handleKeyDown = e => {
      if (e.key === "Enter" || e.key === " ") {
        this.toggleSelectedResources();
      } else {
        onKeyDown?.(e);
      }
    };

    return (
      <div
        ref={ref => {
          if (resourceCardRefs?.current) {
            resourceCardRefs.current[index] = ref;
          }
        }}
        tabIndex={index === 0 ? 0 : -1} // focus on 1st resource card on tab, then navigate using arrow keys
        onKeyDown={handleKeyDown}
        className={selectClassName}
        onClick={() => this.toggleSelectedResources()}
        style={{ pointerEvents: this.isDisabled ? "none" : "auto" }}
      >
        <div className={classes.thumbImageContainer}>
          <img
            className={classes.thumbImage}
            src={thumbURL}
            alt={source}
            onError={event => {
              this.isDisabled = true;

              event.target.src = `${BROKEN_IMAGE_URL}`;

              event.target.classList?.add(classes.errorImage);
            }}
            onLoad={event => {
              if (event.target.src !== `${BROKEN_IMAGE_URL}`) {
                event.target.classList?.remove(classes.errorImage);
              }
            }}
          />
        </div>
        <div className={classes.footerBarContainer}>
          <div className={classes.footerBar}>
            <div className={classes.profileInfo}>
              <ProfileAvtar
                name={profileName}
                profileImage={profileImage}
                size={32}
              />
              <div>
                <div
                  onClick={e => this.onClickView(e, authorUrl)}
                  className={classes.profileName}
                >
                  {profileName}
                </div>
                <div
                  onClick={e => this.onClickView(e, siteUrl)}
                  className={classes.source}
                >
                  {source}
                </div>
              </div>
            </div>
            {this.isSelected() ? (
              <div className={classes.selectedSvg}>
                <Tick width={24} height={24} />
              </div>
            ) : null}
          </div>
          <div className={classes.footBarHoverContainer}></div>
        </div>
      </div>
    );
  }
}
const mapActionCreators = {
  openLinkInNewTab,
};
export default connect(null, mapActionCreators)(ResourceCard);
